import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { IPurchaseOrder, POStatus } from "../../models/PurchaseOrder";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { JVInput } from "../../shared/JVInput";
import { POStatusMap } from "../../models/FDropdown";

interface IReferralBilling {
    billing_ID?: number,
    pO_ID?: number,
    company_Name?: string,
    referral_Amount?: number | null,
    frequency?: string,
    createdBy?: number,
    createdByName?: string,
    createdOn?: Date
}
interface Iprops {
    po: IPurchaseOrder
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

const schema = yup.object({
    company_Name: yup.string().required("Company Name is required"),
    referral_Amount: yup.number().required("Referral Amount is required").typeError("Referral Amount is required"),
    frequency: yup.string().required("Frequency is required")
});

export const RBilling = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<Array<IReferralBilling>>([]);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IReferralBilling>({
        resolver: yupResolver(schema),
        defaultValues: { company_Name: "", referral_Amount: null, frequency: "" }
    });

    const saveToDB = async (body: IReferralBilling) => {
        setLoading(true);
        body.pO_ID = props.po.pO_ID;
        const response = await Fetch("vwPODetails/referralBilling", "POST", body, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Added Successfully" });
            reset();
            loadList();
        } else setLoading(false);
    }

    const deleteFromDB = async (billing_ID: number) => {
        setLoading(true);
        const response = await Fetch("vwPODetails/referralBilling", "DELETE", null, `billing_ID=${billing_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Deleted Successfully" });
            reset();
            loadList();
        } else setLoading(false);
    }

    function onSubmit(data: IReferralBilling) {
        saveToDB(data);
    }

    const loadList = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetails/referralBilling", "GET", null, `po_id=${props.po.pO_ID}`, props.toast);
        if (response) {
            const data: Array<IReferralBilling> = await response.json();
            setList(data);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.open && props.po.pO_ID) loadList();
    }, [props.open, props.po.pO_ID]);

    function onHide() {
        props.hideDialog();
        reset();
        setList([]);
    }

    const actionBodyTemplate = (rowData: IReferralBilling) => {
        return <Button icon="pi pi-trash" label="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => { if (rowData.billing_ID) deleteFromDB(rowData.billing_ID) }} />
    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Referral Billing" className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" value={[props.po]} showGridlines
            >
                <Column field="company_Name_Sales" header="Company Name" />
                <Column field="salesmanager" header="Sales Manager" />
                <Column field="user_Name" header="Recruiter" />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="project_Client_Name" header="End Client" />
                <Column field="project_Start_Date1" header="Start Date" />
                <Column field="bRate" header="B Rate" />
                <Column field="sRate" header="S Rate" />
                <Column field="mRate" header="Margin " />
                <Column field="vendor_Company_Name" header="Client" />
                <Column field="sub_Vendor_Company" header="Vendor" />
                <Column field="pO_Date1" header="PO Date" />
                <Column field="pO_Status" header="Status" body={r => r.pO_Status ? POStatusMap[r.pO_Status] : ''} />
            </DataTable>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVInput required column={3} control={control} label="Company Name" name="company_Name" error={errors.company_Name?.message} />
                <JVInput required column={3} control={control} label="Referral Amount" name="referral_Amount" type="number" error={errors.referral_Amount?.message} />
                <JVInput required column={3} control={control} label="Frequency" name="frequency" error={errors.frequency?.message} />
                <div className="field col-12 md:col-12">
                    <Button loading={loading} label="ADD REFERRAL" type="submit"></Button>
                </div>
            </form>
            <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small" value={list} header="Referral Billing List" showGridlines stripedRows loading={loading}
            >
                <Column field="company_Name" header="Company Name" />
                <Column field="referral_Amount" header="Referral Amount" />
                <Column field="frequency" header="Frequency" />
                <Column field="createdByName" header="Added By" />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
            </DataTable>
        </Dialog>
    );
}